import { basketHasDeliverables, basketPurchasable } from "./basket/helpers";
import { IBasket } from "./basket/types";
import { emailRegex } from "./utils";

const exists = (test: string): boolean => {
  return !!test && test.trim() !== "";
};

export const shippingIsValid = (basket: IBasket): boolean => {
  let errors = [];
  const noDeliverables = !basketHasDeliverables(basket);
  const hasPurchasable = basketPurchasable(basket);
  const hasShipping =
    !!basket.shippingOptionId && basket.shippingOptionId?.trim() !== "";
  const isPickUp =
    basket.shippingOptionId === "00000000-0000-0000-0000-000000000000";

  const emailIsValild = emailRegex.test(basket.address?.contact_email);
  const phoneNotNull = exists(basket.address?.phone_number);
  const hasName = exists(basket.address?.name);
  const coreIsValid = emailIsValild && phoneNotNull && hasName;

  if (!hasShipping && noDeliverables && hasPurchasable && coreIsValid) {
    return true;
  }

  if (hasShipping && coreIsValid) {
    if (isPickUp || noDeliverables) {
      return true;
    } else if (
      exists(basket.address?.line_1) &&
      exists(basket.address?.city) &&
      exists(basket.address?.code)
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
